export const useIsTouchScreen = (): boolean => {
  let result = false

  if (Boolean(window.PointerEvent) && 'maxTouchPoints' in navigator) {
    if (navigator.maxTouchPoints > 0) {
      result = true
    }
  } else {
    if (window.matchMedia?.('(any-pointer:coarse)').matches) {
      result = true
    } else if (Boolean(window.TouchEvent) || 'ontouchstart' in window) {
      result = true
    }
  }
  return result
}
